import axios from "axios";
import { APP_SETTINGS } from "../../config";

export function employeeCheckInOrOut(data, token) {
  // console.log("in api call")
  return axios.post(
    APP_SETTINGS.API_PATH.ATTENDANCE.employeeCheckInOrOut,
    data,
    {
      headers: { Authorization: "Bearer " + token },
    }
  );
}

export function shortLeaveRequest(data, token) {
  // console.log("in api")
  return axios.post(APP_SETTINGS.API_PATH.ATTENDANCE.shortLeaveRequest, data, {
    headers: { Authorization: "Bearer " + token },
  });
}

export function lateCheckIn(data, token) {
  return axios.post(APP_SETTINGS.API_PATH.ATTENDANCE.lateCheckIn, data, {
    headers: { Authorization: "Bearer " + token },
  });
}

export function getEmployeeTodayAttendance(data, token) {
  return axios.post(
    APP_SETTINGS.API_PATH.ATTENDANCE.getEmployeeTodayAttendance,
    { requestId: data },
    {
      headers: { Authorization: "Bearer " + token },
    }
  );
}

export function getRecess(data, token) {
  // console.log("sd",data)
  return axios.post(APP_SETTINGS.API_PATH.ATTENDANCE.shortBreak, data, {
    headers: { Authorization: "Bearer " + token },
  });
}

export function endRecess(data, token) {
  return axios.post(APP_SETTINGS.API_PATH.ATTENDANCE.endBreak, data, {
    headers: { Authorization: "Bearer " + token },
  });
}

export function gettingBreakTypes(token) {
  return axios.post(APP_SETTINGS.API_PATH.ATTENDANCE.getBreakTypes, {
    headers: { Authorization: "Bearer " + token },
  });
}
export function getAttendanceReportByAdminApi(data) {
  return axios.post(
    APP_SETTINGS.API_PATH.ATTENDANCE.getAttendanceReportByAdmin,
    data
  );
}

export function getLeaveRequest(data) {
  return axios.post(APP_SETTINGS.API_PATH.ATTENDANCE.getLeaveRequest, data);
}

export function approveLeaveRequest(data) {
  return axios.post(APP_SETTINGS.API_PATH.ATTENDANCE.approveLeaveRequest, data);
}

export function getEmployeesAttendance(data) {
  return axios.post(
    APP_SETTINGS.API_PATH.ATTENDANCE.getEmployeesAttendance,
    data
  );
}
export function markAttendance(data, token) {
  return axios.post(APP_SETTINGS.API_PATH.ATTENDANCE.markAttendance, data, {
    headers: { Authorization: "Bearer " + token },
  });
}
